import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OrgChartNodeModule } from '../chart-node/chart-node.module';
import { OrgChartDesignerComponent } from './chart-designer.component';

@NgModule({
  declarations: [
    OrgChartDesignerComponent
  ],
  imports: [
    CommonModule,
    OrgChartNodeModule
  ],
  bootstrap: [OrgChartDesignerComponent],
  exports: [OrgChartDesignerComponent]
})
export class OrgChartDesignerModule { }
